import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Popconfirm, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import AgregarDescanso from "./AgregarDescanso/AgregarDescanso";
import EditarDescanso from "./EditarDescanso/EditarDescanso";
import { secondsToHms } from "../../../Components/TimeConvertions";

moment.locale("es");

class Descansos extends Component {
    tableRef = null;
    state = {
        todasDescansos: [],
        loading: false,
        valor: 1,
        modalAgregarDescanso: false,
        modalEditarDescanso: false,
        modalEditarDescansoId: null,
    };
    consultarDescansos(params) {
        this.setState({ loading: true });
        axios
            .post(
                "descansos/selectTodasDescansos",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todasDescansos: [] });
                } else {
                    this.setState({
                        todasDescansos: res.data.data,
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    deshabilitarDescanso(value) {
        this.setState({ loading: true });
        axios
            .post(
                "descansos/deshabilitarDescanso",
                { descansoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Descanso deshabilitado");
                } else {
                    message.error("Sucedio un error y no se pudo deshabilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }
    habilitarDescanso(value) {
        this.setState({ loading: true });
        axios
            .post(
                "descansos/habilitarDescanso",
                { descansoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Descanso habilitado");
                } else {
                    message.error("Sucedio un error y no se pudo habilitar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    agregarDescanso() {
        this.setState({ modalAgregarDescanso: true });
    }
    cerrarAgregarDescanso() {
        this.setState({ modalAgregarDescanso: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
    editarDescanso(id) {
        this.setState({ modalEditarDescanso: true, modalEditarDescansoId: id });
    }
    cerrarEditarDescanso() {
        this.setState({ modalEditarDescanso: false });
        this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "serieNumero",
                render: (value,record) => `${record.serie} - ${record.numero}`,
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "13%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "18%",
            },
            {
                title: "Modalidad",
                dataIndex: "modalidad",
                key: "modalidad",
                width: "10%",
                render: (value) => {
                    return Number(value) === 2
                        ? <Tag color="blue">Flexible</Tag>
                        : <Tag color="default">Fijo</Tag>;
                },
            },
            {
                title: "Inicio",
                dataIndex: "inicioSeg",
                key: "inicioSeg",
                render: (value, record) => {
                    if (Number(record.modalidad) === 2) return "—";
                    return secondsToHms(value)?.format("HH:mm:ss");
                },
                width: "18%",
            },
            {
                title: "Final",
                dataIndex: "finalSeg",
                key: "finalSeg",
                render: (value, record) => {
                    if (Number(record.modalidad) === 2) return "—";
                    return secondsToHms(value)?.format("HH:mm:ss");
                },
                width: "18%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "8%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelado</Tag>;
                    if (value === 1) return <Tag color="green">Activo</Tag>;
                    if (value === 2) return <Tag color="orange">Deshabilitado</Tag>;
                    return "—";
                },
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (value, record) => {
                    let buttons = [];

                    if (this.props.permisoEditarDescanso) {
                        buttons.push(
                            <Tooltip
                                title="Editar Descanso"
                                placement="top"
                                overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                            >
                                <ButtonItem
                                    key={`editar-${record._id}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EditOutlined />}
                                    onClick={() => this.editarDescanso(record._id)}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (this.props.permisoDeshabilitarDescanso) {
                        if (record.estado === 1) {
                            buttons.push(
                                <Popconfirm
                                    key={`deshabilitar-${record._id}`}
                                    title="¿Seguro que quieres deshabilitar este descanso?"
                                    onConfirm={() => this.deshabilitarDescanso(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Deshabilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            lima
                                            icon={<CheckCircleOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        } else {
                            buttons.push(
                                <Popconfirm
                                    key={`habilitar-${record._id}`}
                                    title="¿Seguro que quieres habilitar este descanso?"
                                    onConfirm={() => this.habilitarDescanso(record._id)}
                                    okText="Sí"
                                    cancelText="No"
                                >
                                    <Tooltip
                                        title="Habilitar"
                                        placement="top"
                                        overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}
                                    >
                                        <ButtonItem
                                            type="default"
                                            size="small"
                                            rojo
                                            icon={<StopOutlined />}
                                        >
                                        </ButtonItem>
                                    </Tooltip>
                                </Popconfirm>
                            );
                        }
                    }

                    return <div className="acciones-container">{buttons}</div>;
                }
            },
        ];


        return (
            <>
                <PageHeader
                    title="Descansos"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: 'Deshabilitada', value: 2 }, { label: 'Todos', value: 3 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                            {this.props.permisoAgregarDescanso && (
                                <ButtonItem
                                    type="primary"
                                    key="agregarDescanso"
                                    onClick={this.agregarDescanso.bind(this)}
                                >
                                    Agregar Descanso
                                </ButtonItem>
                            )}
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarDescansos.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todasDescansos}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    filterStorageKey={"descansos" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            if (this.props.permisoEditarDescanso) {
                                this.editarDescanso(record._id);
                            }
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
                <AgregarDescanso
                    visible={this.state.modalAgregarDescanso}
                    cerrarAgregarDescanso={this.cerrarAgregarDescanso.bind(this)}
                />
                <EditarDescanso
                    visible={this.state.modalEditarDescanso}
                    descansoId={this.state.modalEditarDescansoId}
                    cerrarEditarDescanso={this.cerrarEditarDescanso.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarDescanso: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021627899dda241377cee")?.activado,
        permisoEditarDescanso: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021757899dda241377cef")?.activado,
        permisoDeshabilitarDescanso: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f021877899dda241377cf0")?.activado,
    };
};

export default connect(mapStateToProps)(Descansos);
